import type { FaireProductEntity } from "../../entity_types/product";

export const p_dvc55z5255: FaireProductEntity = {
  token: "p_dvc55z5255",
  type: "product",
  name: "Faelys 18K Gold Non-Tarnish Two-Tone Watchband Bracelet",
  brandToken: "b_3tzh9mjdm6",
  brandName: "Flânerie by MAIQ",
  imageUrl:
    "https://cdn.faire.com/fastly/75230706998dc9c44a02a252d8bce167a99061be246ae63aeece47a10e8cdca4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fba1c06dd5b366dfa2fa53befce5cdf4f0413f3bf505e663090d6d7ba258cfa9.jpeg",
    "https://cdn.faire.com/fastly/ad1d3a3b36e1b4f1f8a52ec7a823f89f1a8f393b276acba7e29dfc68bb69bee5.jpeg",
    "https://cdn.faire.com/fastly/81e11fd4890da1ee9e4f45a14ac71ac2f00ef9d36c87d6b88bfd8c9783c88556.jpeg",
    "https://cdn.faire.com/fastly/cb7af1aac9104f3790386a4913d4749781f7b411e2f50f35968132a2289c2f45.jpeg",
  ],
  priceDollars: 14.72,
  description:
    "18K Gold Non-Tarnish Two-Tone Watchband Bracelet\n18K Gold Plating\nStainless Steel\nCubic Zirconia\nMeasurement (L x W inch): 7.06 x 0.39\n \n-Lead-free, Nickel-safe\n- Hypoallergenic\n- Water Resistant",
  tags: [],
  msrpDollars: 48,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:39.527Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
